
import { ElForm, ElMessage, ElMessageBox } from 'element-plus'
import { defineComponent, reactive, toRefs, onMounted, ref } from 'vue'
import Container from '@/components/form/container/Container.vue'
import SearchForm from '@/components/form/search/SearchForm.vue'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import CenterForm from '@/components/form/common/CenterForm.vue'
import NomalContainer from '@/components/dfms-components/container/NomalContainer.vue'
import {
  PrinterModel,
  PrinterPageSearchModel,
  PrinterSearchModel,
  PrinterAddModel,
  PrinterUpdateModel,
  IdsModel
} from '@/model/product/PrinterModel'
import {
  pageSearchPrinter,
  addPrinter,
  updatePrinter,
  removePrinter,
  batchRemovePrinter
} from '@/apis/product/printer'
import { parseTime } from '@/utils'
import { createModel } from '@/utils/component'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  components: {
    Container,
    SearchForm,
    SimpleTable,
    CenterForm,
    NomalContainer
  },
  setup() {
    const { t } = useI18n()
    const searchFormRef = ref(ElForm)
    const searchStruct = [
      { prop: 'printerName', label: t('printer.printerName'), placeholder: t('printer.printerNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'isSupportUsb', label: t('printer.isSupportUsb'), placeholder: t('printer.isSupportUsbP'), component: 'el-select', type: 'text', model: null, options: [{ label: t('printer.isSupportUsbTrue'), value: true }, { label: t('printer.isSupportUsbFalse'), value: false }] },
      { prop: 'isSupportBle', label: t('printer.isSupportBle'), placeholder: t('printer.isSupportBleP'), component: 'el-select', type: 'text', model: null, options: [{ label: t('printer.isSupportBleTrue'), value: true }, { label: t('printer.isSupportBleFalse'), value: false }] },
      { prop: 'isSupportWifi', label: t('printer.isSupportWifi'), placeholder: t('printer.isSupportWifiP'), component: 'el-select', type: 'text', model: null, options: [{ label: t('printer.isSupportWifiTrue'), value: true }, { label: t('printer.isSupportWifiFalse'), value: false }] },
      { prop: 'dpi', label: t('printer.dpi'), placeholder: t('printer.dpiP'), component: 'el-input', type: 'number', model: null },
      { prop: 'printHeadWidth', label: t('printer.printHeadWidth'), placeholder: t('printer.printHeadWidthP'), component: 'el-input', type: 'number', model: null }
    ]

    const createStruct = [
      { prop: 'printerName', label: t('printer.printerName'), placeholder: t('printer.printerNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'isSupportUsb', label: t('printer.isSupportUsb'), placeholder: t('printer.isSupportUsbP'), component: 'el-select', type: 'text', model: null, options: [{ label: t('printer.isSupportUsbTrue'), value: true }, { label: t('printer.isSupportUsbFalse'), value: false }] },
      { prop: 'isSupportBle', label: t('printer.isSupportBle'), placeholder: t('printer.isSupportBleP'), component: 'el-select', type: 'text', model: null, options: [{ label: t('printer.isSupportBleTrue'), value: true }, { label: t('printer.isSupportBleFalse'), value: false }] },
      { prop: 'isSupportWifi', label: t('printer.isSupportWifi'), placeholder: t('printer.isSupportWifiP'), component: 'el-select', type: 'text', model: null, options: [{ label: t('printer.isSupportWifiTrue'), value: true }, { label: t('printer.isSupportWifiFalse'), value: false }] },
      { prop: 'dpi', label: t('printer.dpi'), placeholder: t('printer.dpiP'), component: 'el-input', type: 'number', model: null },
      { prop: 'printHeadWidth', label: t('printer.printHeadWidth'), placeholder: t('printer.printHeadWidthP'), component: 'el-input', type: 'number', model: null }
    ]

    const updateStruct = [
      { prop: 'printerName', label: t('printer.printerName'), placeholder: t('printer.printerNameP'), component: 'el-input', type: 'text', model: null },
      { prop: 'isSupportUsb', label: t('printer.isSupportUsb'), placeholder: t('printer.isSupportUsbP'), component: 'el-select', type: 'text', model: null, options: [{ label: t('printer.isSupportUsbTrue'), value: true }, { label: t('printer.isSupportUsbFalse'), value: false }] },
      { prop: 'isSupportBle', label: t('printer.isSupportBle'), placeholder: t('printer.isSupportBleP'), component: 'el-select', type: 'text', model: null, options: [{ label: t('printer.isSupportBleTrue'), value: true }, { label: t('printer.isSupportBleFalse'), value: false }] },
      { prop: 'isSupportWifi', label: t('printer.isSupportWifi'), placeholder: t('printer.isSupportWifiP'), component: 'el-select', type: 'text', model: null, options: [{ label: t('printer.isSupportWifiTrue'), value: true }, { label: t('printer.isSupportWifiFalse'), value: false }] },
      { prop: 'dpi', label: t('printer.dpi'), placeholder: t('printer.dpiP'), component: 'el-input', type: 'number', model: null },
      { prop: 'printHeadWidth', label: t('printer.printHeadWidth'), placeholder: t('printer.printHeadWidthP'), component: 'el-input', type: 'number', model: null }
    ]

    const printerRole = {
      printerName: [{ required: true, message: t('printer.printerName').concat(t('common.isRequired')), trigger: 'blur' }],
      isSupportUsb: [{ required: true, message: t('printer.isSupportUsb').concat(t('common.isRequired')), trigger: 'blur' }],
      isSupportBle: [{ required: true, message: t('printer.isSupportBle').concat(t('common.isRequired')), trigger: 'blur' }],
      isSupportWifi: [{ required: true, message: t('printer.isSupportWifi').concat(t('common.isRequired')), trigger: 'blur' }],
      dpi: [{ required: true, message: t('printer.dpi').concat(t('common.isRequired')), trigger: 'blur' }],
      printHeadWidth: [{ required: true, message: t('printer.printHeadWidth').concat(t('common.isRequired')), trigger: 'blur' }]
    }

    const tableStruct = [

      { prop: 'printerName', label: t('printer.printerName'), sortable: 'custom' },
      { prop: 'isSupportUsb', label: t('printer.isSupportUsb'), formatter: (row: PrinterModel) => { return row.isSupportUsb ? t('printer.isSupportUsbTrue') : t('printer.isSupportUsbFalse') }, sortable: 'custom' },
      { prop: 'isSupportBle', label: t('printer.isSupportBle'), formatter: (row: PrinterModel) => { return row.isSupportBle ? t('printer.isSupportBleTrue') : t('printer.isSupportBleFalse') }, sortable: 'custom' },
      { prop: 'isSupportWifi', label: t('printer.isSupportWifi'), formatter: (row: PrinterModel) => { return row.isSupportWifi ? t('printer.isSupportWifiTrue') : t('printer.isSupportWifiFalse') }, sortable: 'custom' },
      { prop: 'dpi', label: t('printer.dpi'), sortable: 'custom' },
      { prop: 'printHeadWidth', label: t('printer.printHeadWidth'), sortable: 'custom' },
      { prop: 'createTime', label: t('common.createTime'), formatter: (row: PrinterModel) => { return parseTime(row.createTime) }, sortable: 'custom' },
      { prop: 'updateTime', label: t('common.updateTime'), formatter: (row: PrinterModel) => { return parseTime(row.updateTime) }, sortable: 'custom' }
    ]
    const dataMap = reactive({
      searchFormStruct: searchStruct,
      searchFormModel: createModel(searchStruct) as PrinterSearchModel,
      tableData: Array<PrinterModel>(),
      columnStruct: tableStruct,
      listLoading: true,
      selection: Array<number>(),
      limit: 10,
      total: 0,
      page: 1,
      sort: 'createTime',
      order: 'desc',
      dialogStatus: 'create',
      textMap: {
        update: 'printer.edit',
        create: 'printer.create'
      },
      dialogFormVisible: false,
      printerRole: printerRole,
      createStruct: createStruct,
      createModel: createModel(createStruct) as PrinterAddModel,
      updateStruct: updateStruct,
      updateModel: createModel(updateStruct) as PrinterUpdateModel,
      editRow: {} as PrinterModel,
      handleSelection(item: any[]) {
        dataMap.selection = item
      },
      handleCurrentChange(page?: any) {
        dataMap.page = page
        dataMap.getList()
      },
      handleSizeChange(val: any) {
        dataMap.limit = val
        dataMap.getList()
      },
      handleOrder(column: any) {
        dataMap.sort = column.prop
        dataMap.order = column.order === 'descending' ? 'desc' : 'asc'
        dataMap.getList()
      },
      async getList() {
        dataMap.listLoading = true
        const params: PrinterPageSearchModel = {
          printerName: dataMap.searchFormModel.printerName,
          isSupportUsb: dataMap.searchFormModel.isSupportUsb,
          isSupportBle: dataMap.searchFormModel.isSupportBle,
          isSupportWifi: dataMap.searchFormModel.isSupportWifi,
          dpi: dataMap.searchFormModel.dpi,
          printHeadWidth: dataMap.searchFormModel.printHeadWidth,
          page: dataMap.page,
          limit: dataMap.limit,
          sort: dataMap.sort,
          order: dataMap.order
        }
        const data = await pageSearchPrinter(params)
        dataMap.tableData = data?.data?.records ?? []
        const total = data?.data?.total ?? '0'
        dataMap.total = parseInt(total)

        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      submitSearch() {
        dataMap.page = 1
        dataMap.getList()
      },
      resetForm() {
        console.log('reset')
      },
      async createSubmit() {
        const createData: PrinterAddModel = {
          printerName: dataMap.createModel.printerName,
          isSupportUsb: dataMap.createModel.isSupportUsb,
          isSupportBle: dataMap.createModel.isSupportBle,
          isSupportWifi: dataMap.createModel.isSupportWifi,
          dpi: dataMap.createModel.dpi,
          printHeadWidth: dataMap.createModel.printHeadWidth
        }
        const result = await addPrinter(createData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.createSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async updateNameSubmit() {
        const updateData: PrinterUpdateModel = {
          id: dataMap.updateModel.id,
          printerName: dataMap.updateModel.printerName,
          isSupportUsb: dataMap.updateModel.isSupportUsb,
          isSupportBle: dataMap.updateModel.isSupportBle,
          isSupportWifi: dataMap.updateModel.isSupportWifi,
          dpi: dataMap.updateModel.dpi,
          printHeadWidth: dataMap.updateModel.printHeadWidth
        }
        const result = await updatePrinter(updateData)
        dataMap.dialogFormVisible = false
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.updateSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async deleteData(id: number) {
        const result = await removePrinter(id)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      async bathDeleteData() {
        const deleteData: IdsModel = { ids: dataMap.selection }
        const result = await batchRemovePrinter(deleteData)
        dataMap.getList()
        if (result?.code === 0) {
          ElMessage({
            message: t('common.deleteSuccess'),
            type: 'success',
            duration: 2000
          })
        } else {
          ElMessage({
            message: result?.message,
            type: 'error',
            duration: 2000
          })
        }
      },
      updateNameReset() {
        console.log('update reset')
        dataMap.updateModel.id = dataMap.editRow.id
        dataMap.updateModel.printerName = dataMap.editRow.printerName
        dataMap.updateModel.isSupportUsb = dataMap.editRow.isSupportUsb
        dataMap.updateModel.isSupportBle = dataMap.editRow.isSupportBle
        dataMap.updateModel.isSupportWifi = dataMap.editRow.isSupportWifi
        dataMap.updateModel.dpi = dataMap.editRow.dpi
        dataMap.updateModel.printHeadWidth = dataMap.editRow.printHeadWidth
      },
      createReset() {
        console.log('create reset')
      }
    })
    const handleCreate = () => {
      dataMap.dialogStatus = 'create'
      dataMap.dialogFormVisible = true
    }
    const handleEdit = (row?: PrinterModel) => {
      if (row) {
        dataMap.editRow = row
        dataMap.dialogStatus = 'update'
        dataMap.updateModel.id = row.id
        dataMap.updateModel.printerName = row.printerName
        dataMap.updateModel.isSupportUsb = row.isSupportUsb
        dataMap.updateModel.isSupportBle = row.isSupportBle
        dataMap.updateModel.isSupportWifi = row.isSupportWifi
        dataMap.updateModel.dpi = row.dpi
        dataMap.updateModel.printHeadWidth = row.printHeadWidth
        dataMap.dialogFormVisible = true
      }
    }
    const handleDelete = (id: number) => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.deleteData(id)
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    const handleBathDelete = () => {
      ElMessageBox.confirm(t('common.deleteTip'), t('message.tip'), {
        confirmButtonText: t('message.confirm'),
        cancelButtonText: t('message.cancel'),
        type: 'warning'
      }).then(async() => {
        await dataMap.bathDeleteData()
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: t('common.cancelDelete'),
          duration: 2000
        })
      })
    }
    onMounted(() => {
      dataMap.getList()
    })
    return {
      t,
      handleCreate,
      handleEdit,
      handleDelete,
      handleBathDelete,
      searchFormRef,
      ...toRefs(dataMap)
    }
  }
})
